import { Basket } from "@/services/model/basket";

// The basket is a trial checkout if the first entry is
export const isTrialCheckout = (basket: Basket): boolean => {
  const entry = basket.entries["0"];

  return entry?.options?.[0]?.discounts?.[0]?.discountName === "Free_Trial";
};

// If balance is negative, it is the available credit, if positive it is the overall amount the user needs to pay in case of manual billing (and we ignore it)
export const getCreditAmount = (balance?: number) =>
  balance && balance < 0 ? Math.abs(balance) : 0;

/**
 * Basket discount labels sometimes include a tariff suffix from the backend
 * (e.g. "Friends with Benefits 30% FM Plus Month"). Keep the name through the
 * percent sign and drop the rest for UI display.
 */
export const formatDiscountDisplayName = (discountName?: string) => {
  if (!discountName) {
    return discountName;
  }

  const percentIndex = discountName.indexOf("%");

  return percentIndex === -1
    ? discountName.trim()
    : discountName.slice(0, percentIndex + 1).trim();
};
